// import logo from './logo.svg';
import './App.css';
import React from 'react';
import Home from './pages/Home';
// import Navbar from './components/Navbar';
// import Review from './pages/Review';
// import { BrowserRouter as Router,Routes,Route } from 'react-router-dom';


function App() {

  return (
    <>

<Home/>
      {/* <Router>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/review' element={<Review/>}/>

          </Routes>
        </Router> */}
      
        

        
    
    </>
    
  );
}

export default App;
